import Vue from 'vue';
import Similar from '../components/similar.vue';

new Vue({
    el: '#similar-vue',
    render: h => h(Similar)
});